import {Injectable} from '@angular/core';
import {FormbirdInjectorService} from '../injector/formbird-injector.service';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  dataService: any;

  constructor(private injector: FormbirdInjectorService) {
    this.dataService = injector.get('DataService');
  }

  public printMessage(message, messageType?, title?, position?, preventDuplicate?, displayDesktopNotification?,
                      onClickFunction?, timeOut?, isPermanent?) {
    return this.dataService.printMessage(message, messageType, title, position, preventDuplicate, displayDesktopNotification,
      onClickFunction, timeOut, isPermanent);
  }


  /*
   insert function
   parameters:
   bean - the bean to insert
   successFunction - a function to execute on success to do post save steps
   cachingRequired - whether to save the record to the local database. Records that never need
   to be loaded in the app on their own, such as events, can have this set to false
   */
  async insert(bean, cachingRequired?): Promise<any> {
    return this.dataService.insert(bean, cachingRequired);
  }

  /**
   * get a document
   */
  async getDocument(id: string): Promise<any> {
    return this.dataService.getDocument(id);
  }

  /*
   execute component function
   parameters:
   options - object, should contin functionName, componentWebServiceName and functionParameters
   */
  async executeComponentFunction(options): Promise<any> {
    return this.dataService.executeComponentFunction(options);
  }

}
